<template>
  <svg
    id="Layer_1"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 51.55 51.55"
    style="enable-background: new 0 0 51.55 51.55;"
    xml:space="preserve"
  >
    <g>
      <g>
        <path
          :fill="color"
          d="M39.15,3.26c-5,0-9.01,4.02-9.01,9.01c0,5,4.02,9.01,9.01,9.01s9.01-4.02,9.01-9.01C48.16,7.28,44.15,3.26,39.15,3.26z M39.15,17.37c-2.84,0-5.09-2.25-5.09-5.09c0-2.84,2.25-5.09,5.09-5.09c2.84,0,5.09,2.25,5.09,5.09C44.24,15.02,41.89,17.37,39.15,17.37z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M39.15,30.26c-5,0-9.01,4.02-9.01,9.01c0,5,4.02,9.01,9.01,9.01s9.01-4.02,9.01-9.01C48.16,34.28,44.15,30.26,39.15,30.26z M39.15,44.37c-2.84,0-5.09-2.25-5.09-5.09c0-2.84,2.25-5.09,5.09-5.09c2.84,0,5.09,2.25,5.09,5.09C44.24,42.02,41.89,44.37,39.15,44.37z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M12.4,16.18c-5,0-9.01,4.02-9.01,9.01c0,5,4.02,9.01,9.01,9.01s9.01-4.02,9.01-9.01C21.41,20.2,17.4,16.18,12.4,16.18z M12.4,30.29c-2.84,0-5.09-2.25-5.09-5.09c0-2.84,2.25-5.09,5.09-5.09c2.84,0,5.09,2.25,5.09,5.09C17.5,27.94,15.14,30.29,12.4,30.29z"
        />
      </g>
      <g>
        <rect
          :fill="color"
          x="18.83"
          y="15.77"
          transform="matrix(0.901 -0.4338 0.4338 0.901 -5.371 12.9992)"
          width="13.93"
          height="5"
        />
      </g>
      <g>
        <rect
          :fill="color"
          x="21.51"
          y="24.45"
          transform="matrix(0.3304 -0.9438 0.9438 0.3304 -15.0617 44.7557)"
          width="5"
          height="17.08"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'ShareIcon',
  props: {
    color: {
      type: String,
      required: true,
    },
  },
};
</script>
